// Field Configuration for Document Info Panel
// Extracted from App.ts to centralize field definitions

// Field types
export type FieldType = 'text' | 'textarea' | 'autocomplete' | 'select' | 'tags' | 'readonly';
export type FieldLayout = 'full' | 'compact';

export interface FieldDefinition {
  type: FieldType;
  layout: FieldLayout;
  options?: string[];
}

// Option constants
export const RESOURCE_CATEGORIES = [
  'Content Creation',
  'Business',
  'Marketing',
  'Paid Ads',
  'Desarrollo Personal',
  'Programming',
  'Video Editing',
  'Recording Camera',
  'AI Prompts',
  'Hyperfocus Dopamine',
  'AdsConcierge',
  'Site Projects',
  'Personal Brand',
  'Journaling',
  'GTM',
  'Saas',
  'Audience Knowledge',
  'Dataset/ads',
  'Dataset/Reels',
  'Dataset/Stories',
  'Dataset/Vlog',
  'Dataset/Thumbnails',
  'Inspiracion',
  'Ideas Contenido',
  'Uncategorized'
] as const;

export const CONTENT_FORMATS = [
  'Reel',
  'Video',
  'Carousel',
  'Image',
  'Story',
  'Thread',
  'Blog Post',
  'Article',
  'Newsletter',
  'Podcast'
] as const;

export const PLATFORMS = [
  'YouTube',
  'Instagram',
  'TikTok',
  'Twitter/X',
  'LinkedIn',
  'Facebook',
  'Email',
  'Blog',
  'Podcast',
  'Other'
] as const;

export const INTENTS = [
  'Read Later',
  'Implement',
  'Reference',
  'Share',
  'Archive'
] as const;

export const STATUSES = [
  'Draft',
  'In Progress',
  'Review',
  'Published',
  'Archived'
] as const;

// Field configuration
export const FIELD_CONFIG: Record<string, FieldDefinition> = {
  summary: { type: 'textarea', layout: 'full' },
  outline: { type: 'textarea', layout: 'full' },
  speakers: { type: 'text', layout: 'full' },
  url: { type: 'text', layout: 'full' },
  author: { type: 'text', layout: 'compact' },
  project: { type: 'autocomplete', layout: 'compact' },
  area: { type: 'select', layout: 'compact', options: [] },
  tags: { type: 'tags', layout: 'full' },
  resourceCategory: { type: 'select', layout: 'compact', options: [...RESOURCE_CATEGORIES] },
  contentFormat: { type: 'select', layout: 'compact', options: [...CONTENT_FORMATS] },
  platform: { type: 'select', layout: 'compact', options: [...PLATFORMS] },
  intent: { type: 'select', layout: 'compact', options: [...INTENTS] },
  status: { type: 'select', layout: 'compact', options: [...STATUSES] },
  date: { type: 'readonly', layout: 'compact' }
};

// Default visible fields
export const DEFAULT_VISIBLE_FIELDS = ['summary'];
